import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoryboardPublishRoutingModule } from './storyboard-publish-routing.module';
import { StoryboardPublishComponent } from './storyboard-publish.component';
import {VgCoreModule} from "videogular2/core";
import {VgControlsModule} from "videogular2/controls";
import {VgOverlayPlayModule} from "videogular2/overlay-play";
import {VgBufferingModule} from "videogular2/buffering";
import { StoryboardProgressBarComponent } from './storyboard-progress-bar/storyboard-progress-bar.component';

@NgModule({
  imports: [
    CommonModule,
    StoryboardPublishRoutingModule,
    VgCoreModule,
    VgControlsModule,
    VgOverlayPlayModule,
    VgBufferingModule,
  ],
  declarations: [StoryboardPublishComponent, StoryboardProgressBarComponent]
})
export class StoryboardPublishModule { }



// WEBPACK FOOTER //
// ./src/app/storyboard-publish/storyboard-publish.module.ts